import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

import { computed } from "vue";
import {
  ArtifactSchema,
  EntityModificationSchema,
  TraceLinkSchema,
  SelectOption,
  ArtifactDeltaButtonGroupProps,
} from "@/types";
import { capitalize, getEnumColor } from "@/util";
import { ExpansionItem } from "@/components/common";
import ArtifactDeltaButton from "./ArtifactDeltaButton.vue";


/**
 * Displays a group of delta buttons.
 */
const __default__ = {
  name: "DeltaButtonGroup",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    deltaType: {},
    items: {},
    isTraces: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const itemCount = computed(() => Object.keys(props.items).length);
const title = computed(
  () => `${itemCount.value} ${capitalize(props.deltaType)}`
);

const className = computed(() => `q-mb-sm bd-${getEnumColor(props.deltaType)}`);

/**
 * Converts all delta artifacts and traces into a list of select options.
 */
const itemFields = computed<SelectOption[]>(() => {
  const items = Object.values(props.items);

  if (props.isTraces) {
    return (items as TraceLinkSchema[]).map(
      ({ traceLinkId, sourceName, targetName }) => ({
        id: traceLinkId,
        name: `${sourceName} > ${targetName}`,
      })
    );
  } else {
    return props.deltaType === "modified"
      ? (items as EntityModificationSchema<ArtifactSchema>[]).map(
          ({ after: { id, name } }) => ({ id, name })
        )
      : (items as ArtifactSchema[]).map(({ id, name }) => ({ id, name }));
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ExpansionItem), {
    "model-value": itemFields.value.length > 0,
    label: title.value,
    class: _normalizeClass(className.value),
    style: {"border-width":"0 0 0 2px !important","border-radius":"0 !important"}
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(itemFields.value, ({ name, id }) => {
        return (_openBlock(), _createBlock(ArtifactDeltaButton, {
          key: name,
          name: name,
          "delta-type": props.deltaType,
          onClick: ($event: any) => (emit('click', id))
        }, null, 8, ["name", "delta-type", "onClick"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["model-value", "label", "class"]))
}
}

})